import { isFeatureFlagEnabled } from '../entities/feature-flag';

export default {
	created(el, binding) {
		if (!binding.value) return;

		const feature = binding.value.feature;
		if (!isFeatureFlagEnabled(feature)) {
			el.style.display = 'none';
		}
	},
};